import apiClient from '@shared/services/apiClient';
import type { ClinicHierarchy, CreateClinicHierarchyRequest, UnassignedClinic } from '../types/clientClinic';

export const getClinicHierarchyTree = async (): Promise<ClinicHierarchy[]> => {
  const response = await apiClient.get('/clinic-hierarchy/tree');
  return response.data;
};

export const getClinicHierarchyByClinicId = async (clinicId: number): Promise<ClinicHierarchy> => {
  const response = await apiClient.get(`/clinic-hierarchy/clinic/${clinicId}`);
  return response.data;
};

export const getClinicHierarchyChildren = async (parentClinicId: number): Promise<ClinicHierarchy[]> => {
  const response = await apiClient.get(`/clinic-hierarchy/children/${parentClinicId}`);
  return response.data;
};

export const createClinicHierarchy = async (
  request: CreateClinicHierarchyRequest
): Promise<ClinicHierarchy> => {
  const response = await apiClient.post('/clinic-hierarchy', request);
  return response.data;
};

export const updateClinicHierarchy = async (
  clinicId: number,
  parentClinicId: number
): Promise<ClinicHierarchy> => {
  const response = await apiClient.put(`/clinic-hierarchy/clinic/${clinicId}`, { parentClinicId });
  return response.data;
};

export const deleteClinicHierarchy = async (clinicId: number): Promise<void> => {
  await apiClient.delete(`/clinic-hierarchy/clinic/${clinicId}`);
};

export const getUnassignedClinics = async (search?: string): Promise<UnassignedClinic[]> => {
  const params = search ? `?search=${encodeURIComponent(search)}` : '';
  const response = await apiClient.get(`/clinic-hierarchy/unassigned${params}`);
  return response.data;
};
